module.exports = function (obj, key) {
  return obj.hasOwnProperty(key);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/object/has.js
// module id = 150
// module chunks = 0 1 2